import { CopyId } from "@/components/copy-id";
import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import { type Vehicle } from "@/providers/vehicles.provider";
import { IconCar, IconMotorbike } from "@tabler/icons-react";

export function VehicleTypeBadge({ type }: { type: Vehicle["vehicle_type"] }) {
  if (type === "motorcycle")
    return (
      <Badge variant="secondary" className="gap-1">
        <IconMotorbike className="size-3" />
        Motorcycle
      </Badge>
    );
  return (
    <Badge variant="outline" className="gap-1">
      <IconCar className="size-3" />
      Car
    </Badge>
  );
}

export function VehicleRow({
  vehicle,
  onClick,
}: {
  vehicle: Vehicle;
  onClick: () => void;
}) {
  const createdAt = new Date(vehicle.created_at).toLocaleDateString();
  const displayName = vehicle.nickname
    ? `${vehicle.make} ${vehicle.model} "${vehicle.nickname}"`
    : `${vehicle.make} ${vehicle.model}`;

  return (
    <TableRow className="cursor-pointer" onClick={onClick}>
      <TableCell>
        <CopyId id={vehicle.vehicle_id} />
      </TableCell>
      <TableCell className="font-medium">{displayName}</TableCell>
      <TableCell className="tabular-nums">{vehicle.year}</TableCell>
      <TableCell>
        <VehicleTypeBadge type={vehicle.vehicle_type} />
      </TableCell>
      <TableCell className="text-muted-foreground">
        {vehicle.drive ?? "—"}
      </TableCell>
      <TableCell className="text-muted-foreground">
        {vehicle.transmission === "A"
          ? "Automatic"
          : vehicle.transmission === "M"
            ? "Manual"
            : "—"}
      </TableCell>
      <TableCell className="text-muted-foreground">
        {vehicle.horsepower != null ? `${vehicle.horsepower} hp` : "—"}
      </TableCell>
      <TableCell className="text-muted-foreground text-xs">
        {createdAt}
      </TableCell>
    </TableRow>
  );
}
